/**
 * Another person's AI agent at work, as a kanban card (design board "Sessions kanban"): who drives it, what it writes,
 * its step and model when known. Never their prompts. "Watch" opens the project following the agent's files.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { inkFor } from '../../utils/participantColors';
import { ParticipantMark } from '../presence/Presence';
import VendorName from '../sandbox/VendorName';
import './Workspace.css';

export default function LiveAgentCard({ card, onWatch = null }) {
  const { agent } = card;
  return (
    <div className="session-kanban-card live-agent-card" data-testid="live-agent-card" style={{ '--presence-ink': inkFor(agent.slot) }}>
      <div className="session-kanban-card-name"><VendorName name={agent.label}>{card.title}</VendorName></div>
      {card.project && <div className="session-kanban-card-project">{card.project}</div>}
      <div className="editing-now-row is-agent">
        <ParticipantMark agent initials={agent.driver?.initials || 'AI'} paused={Boolean(agent.paused)} size={16} slot={agent.slot} />
        <span>{agent.paused ? <strong>Paused</strong> : <><strong>Editing now</strong> · {card.detail}</>}</span>
      </div>
      {onWatch && (
        <div className="session-kanban-card-footer">
          <span className="session-kanban-card-time">now</span>
          <button className="collab-link" onClick={(event) => { event.stopPropagation(); onWatch(card); }} type="button">Watch</button>
        </div>
      )}
    </div>
  );
}

LiveAgentCard.propTypes = {
  card: PropTypes.shape({
    agent: PropTypes.object.isRequired,
    detail: PropTypes.string,
    project: PropTypes.string,
    title: PropTypes.string,
  }).isRequired,
  onWatch: PropTypes.func,
};
